<template>
  <div class="passengers">

    <div class="card" v-for="(transaction, index) in items" :key="index">
      <div class="list__item">
        <div> {{transaction.description}} </div>
        <div> {{ transaction.amount | nairaSign }} </div>
        <div class="transation--ref"> {{ transaction.ref }} </div>
        <div :class="'text-strong status--'+transaction.status"> {{ transaction.status }} </div>
        <div class="text-light"> {{ transaction.created_at | cleanDate }} </div>
        <div class="list--item__actions">
          <el-button size="mini" type="warning"> Paid By </el-button>
          <el-button size="mini" type="primary"> Verify</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Transactions',
  props: ['items']
}
</script>

<style lang="scss" src="./transactions.scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/transactions/Transactions.vue